import ColumnSix from '../ColumnSix';

export default function index(props) {
  // const { data, primaryCategory, installLink,installAppLink,contentId,contentType,contentData } = props;
  return (
    <div>
      <ColumnSix
        // installLink={installLink}
        // data={data}
        // primaryCategory={primaryCategory}
        {...props}
      />
      {/* <Columnfour /> */}
    </div>
  );
}
